module.exports = __webpack_public_path__ + "img/xiaoshou.684dabf2.png";